// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { priceStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { css } from "styled-components";


priceStyles.productPrice = {
    price: {
        priceText: {
            variant: "h2",
            forwardAs: "span",
            css: css`
                display: inline;
                font-size: 28px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 13,
                weight: 400,
                css: css`
                    line-height: 20px;
                `,
            },
        },
    },
    priceWrapper: {
        css: css`
            max-height: unset;
        `,
    },
};